var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorsLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 358 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    width: 59,
    height: 6,
    fill: "#A664A1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    width: 60,
    height: 6,
    fill: "#A664A1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    width: 60,
    height: 6,
    fill: "#006AB3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    width: 60,
    height: 6,
    fill: "#2D8F2E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    width: 60,
    height: 6,
    fill: "#FCC521"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    width: 60,
    height: 6,
    fill: "#F29400"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 298,
    width: 60,
    height: 6,
    fill: "#E2001A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsLine);
export default __webpack_public_path__ + "static/media/colors-line.9ee2a31f0ec9cc7b75a03aac59d5843c.svg";
export { ForwardRef as ReactComponent };